import { connect } from 'react-redux';
import { registerSnackbar, deregisterSnackbar, hideSnackbar } from './Snackbar.reducer';
import Snackbar from './Snackbar';
import { selectSnackbarInfo } from './Snackbar.selectors';

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps;
  const { type, messageProps, targetId, icon, isLowStyle, description } = selectSnackbarInfo(state);

  return {
    ...ownProps,
    type,
    messageProps: id === targetId ? messageProps : null,
    icon,
    isLowStyle,
    description,
  };
};

const mapDispatchToProps = { registerSnackbar, deregisterSnackbar, hideSnackbar };

export default connect(mapStateToProps, mapDispatchToProps)(Snackbar);
